/*
 * @Description:
 * @Author: 宋信峰
 * @Date: 2022-08-11 14:05:44
 * @LastEditTime: 2022-09-23 10:37:15
 * @LastEditors: 宋信峰
 * @Reference:
 */
import request from "./http";

export function lists(data = {}) {
  const params = {
    prov_id: data.prov_id || null,
    mold_id: data.mold_id || null,
    mold_ids: data.mold_ids || null,
    search: data.search || null,
    search_file: data.search_file || null,
    page: data.page || 1,
    page_size: data.page_size || 9
  };
  return request.post("html/index/productShow", params);
}

export function detail() {}

export function myProducts(data) {
  return request.post("html/user/myProduct", data);
}

export function deleteProduct(data) {
  return request.post("html/User/delMyProduct", data);
}

export function create(data) {
  return request.post("html/Release/productRelease", data);
}

export function editDetail(data) {
  return request.post("html/user/myProductDetail", data);
}

export function edit(data) {
  return request.post("html/User/editMyProduct", data);
}
